import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { DraftCalculusTablePermissions } from '@retail/calculus/types';
import { useDraftAffectedItemsColumnDefs } from './useDraftAffectedItemsColumnDefs';
import { OrgUnitType } from '@retail/mgpris/config-types';
import { Box, Stack } from '@mui/material';
import { AssortmentPricesComparison } from '@retail/my-assortment/types';

interface Props {
  items: AssortmentPricesComparison[];
  loading: boolean;
  includeVat: boolean;
  permissions: DraftCalculusTablePermissions;
  orgType: OrgUnitType;
}

export function DraftAffectedItemsTable({
  items,
  loading,
  includeVat,
  permissions,
  orgType,
}: Props) {
  const columnConfigs: { show: boolean; column: GridColDef<AssortmentPricesComparison> }[] =
    useDraftAffectedItemsColumnDefs({ permissions, includeVat: includeVat, orgType });

  const columns = columnConfigs.filter(({ show }) => show).map(({ column }) => column);

  return (
    <Stack height="100%" width="100%" maxWidth="100%">
      <Box sx={{ flexGrow: 1, position: 'relative' }}>
        <Box sx={{ position: 'absolute', inset: 0 }}>
          <DataGridPremium<AssortmentPricesComparison>
            disableRowSelectionOnClick
            rowHeight={65}
            rows={items}
            getRowId={(row) => row.draft.mgSupplierItemId}
            columns={columns}
            loading={loading}
            disableColumnMenu
            disableColumnResize
            disableColumnReorder
            hideFooter
          />
        </Box>
      </Box>
    </Stack>
  );
}
